import {useState} from "react";

type TModalKey =
  | "sheet"
  | "modal"
  | "details"
  | "detail"
  | "filters"
  | "delete"
  | "cancel"
  | "confirmation"
  | "property_transfer"
  | "amenity_access"
  | "turnover"
  | "deactivate"
  | "reactivate"
  | "enable"
  | "disable"
  | "schedule"
  | "toggle-status"
  | "correct"
  | "citation-create"
  | `${string}-sheet`
  | `${string}-dialog`;

export default function useModal<T>() {
  const [modalKey, setModalKey] = useState<TModalKey | null>(null);
  const [itemId, setItemId] = useState<number | null>(null);
  const [item, setItem] = useState<T | null>(null);

  const handleOpenModal = (key: TModalKey | string, id?: number, item?: T) => {
    setModalKey(key as TModalKey);
    setItemId(id ?? null);
    setItem(item ?? null);
  };

  const handleCloseModal = () => {
    setModalKey(null);
    setItemId(null);
    setItem(null);
  };

  return {
    modalKey,
    itemId,
    item,
    onOpenModal: handleOpenModal,
    onCloseModal: handleCloseModal,
  };
}
